<template>
    <div class="[ u-grid__item u-1/3@wide ] c-live__list">
        <div class="o-dayswitch">
            <button class="o-dayswitch__button o-dayswitch__previous" @click.stop="$store.dispatch('program/fetchPrevious')">
              <SvgIcon aria-hidden="true" class="o-dayswitch__icon" icon="arrow-left" />
            </button>
            <h3 class="o-dayswitch__title">
              <span>{{dateName}}</span>
              <em class="o-dayswitch__subtitle">{{displayDate}}</em>
            </h3>
            <button class="o-dayswitch__button o-dayswitch__next" @click.stop="$store.dispatch('program/fetchNext')">
              <SvgIcon aria-hidden="true" class="o-dayswitch__icon" icon="arrow-right" />
            </button>
        </div>
        <ol class="o-timetable">
            <li v-for="broadcast in broadcasts" :key="broadcast.id" class="o-timetable__item o-block-link"
              v-bind:class="{ 'o-timetable__item--active': broadcast.id === program.id }">
              <span class="o-timetable__time">{{broadcast.start}}</span>
              <a v-if="broadcast.url" class="o-timetable__link o-link--secondary" :href="broadcast.url">{{broadcast.title}}</a>
              <span v-else>{{broadcast.title}}</span>
            </li>
        </ol>
    </div>
</template>

<script>
import { format, isSameDay, startOfDay, parseISO, differenceInDays } from 'date-fns'
import { nl } from 'date-fns/locale'
import { mapState } from 'vuex';

const LONG_FORMAT = 'EEEE d MMMM';
const HOUR_FORMAT = 'HH:mm';

export default {
  name: 'ProgramList',
  data() {
    return {
      active: null,
    };
  },
  computed: {
    ...mapState({
      broadcasts: function(state) {
        return state.program.broadcasts
          .filter(broadcast =>
            isSameDay(parseISO(broadcast.start), state.program.broadcastsDate) && broadcast.presenters.length > 0
          )
          .map(broadcast => ({
          ...broadcast,
          start: format(parseISO(broadcast.start), HOUR_FORMAT),
        }));
      },
      program: state => state.program.program,
      displayDate: state => format(state.program.broadcastsDate, LONG_FORMAT, {locale: nl}),
      dateName(state) {
        const diff = differenceInDays(startOfDay(state.program.broadcastsDate), startOfDay(new Date()))
        if (diff == 0) {
          return 'Vandaag'
        } else if (diff == -1) {
          return 'Gisteren'
        } else if (diff == -2) {
          return 'Eergisteren'
        } else if (diff == 1) {
          return 'Morgen'
        } else if (diff == 2) {
          return 'Overmorgen'
        } else {
          return format(state.program.broadcastsDate, 'EEEE', {locale: nl})
        }
      }
    }),
  },
  created() {
    this.$store.dispatch('program/fetchToday');
  },
};
</script>
